// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import { validateRequired } from '@ion/components/src/components/form/validators';
import { CONSENT_MODES } from '@ion/api/consent-modes/modes';

export default function buildConsentCategorySelectProps({ formState, setField, consentMode, ...props }) {
  const defaultProps = {
    name: 'consentCategory',
    validators: [validateRequired()],
    disabled: false,
    value: formState.consentCategory.value,
    errorMsg: formState.consentCategory.errorMsg,
    onChange: setField,
    placeholder: 'Select Consent Categories',
    ...props,
  };

  // `disabled` doesn't exclude the hidden input from submit validation, so External must clear validators.
  if (consentMode === CONSENT_MODES.external) {
    return {
      ...defaultProps,
      validators: [], // explicit clear; without this, defaultProps.validators leaks through
      disabled: true,
      placeholder: 'Not Applicable',
    };
  }

  return defaultProps;
}
